import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";
import { PagamentoConfig } from "../../types/PagamentoConfig";
import { queryKeys } from "../api/queryKeys";

/**
 * Qual adquirente atende o cliente logado e, quando for SafraPay, as credenciais que o SDK
 * `SafraPayTransparent` precisa para tokenizar o cartão no navegador.
 *
 * Precisa ser consultado ANTES de montar a tela de cartão: no fluxo SafraPay o número do
 * cartão não pode ser enviado ao backend, tem que ser trocado por um token antes.
 *
 * Um erro aqui NÃO é tratado como "sem adquirente": quem consome cai no comportamento
 * padrão (Pagar.me), que é o que o conexão sempre fez. Ver `CreditCard`.
 */
export const usePagamentoConfig = (enabled: boolean = true) => {
  return useQuery<PagamentoConfig>({
    queryKey: queryKeys.pagamentoConfig(),
    queryFn: async () => {
      const response = await api.get<PagamentoConfig>("pagamento/config");

      if (response.status !== 200) {
        throw new Error(
          "Não foi possível consultar a configuração de pagamento"
        );
      }

      return response.data;
    },
    enabled,
    // A adquirente do cliente não muda dentro de uma sessão de compra: ela vem do grupo de
    // positivação, com vigência por data. Não faz sentido refazer a chamada a cada montagem
    // da tela de pedido.
    staleTime: 30 * 60 * 1000,
    retry: 1,
  });
};
